module.exports = __webpack_public_path__ + "static/What-are-wireframes-A-beginners-guide-2a4396d9cebb46d22f0fe0c33e51cfd0.png";